// A short note at the bottom of the map (state/note.ts), e.g. "Coming soon: sign-in" when a personal control is
// tapped on the public site. Slides in, stays NOTE_MS (longer while hovered or focused), slides out.
import { useEffect, useState } from "react";
import { hideNote, useNote } from "../state/note";
import styles from "./Note.module.css";

const NOTE_MS = 2500;

export function Note() {
  const { text, seq } = useNote();
  const [shown, setShown] = useState<string | null>(null);
  const [leaving, setLeaving] = useState(false);
  const [held, setHeld] = useState(false);
  useEffect(() => { if (text) { setShown(text); setLeaving(false); } else if (shown) setLeaving(true); }, [text, seq]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!text || held) return;
    const t = setTimeout(hideNote, NOTE_MS);
    return () => clearTimeout(t);
  }, [text, seq, held]);
  if (!shown) return null;
  return (
    <div id="note" role="status" className={leaving ? `${styles.note} ${styles.leaving}` : styles.note}
      onAnimationEnd={() => { if (leaving) { setShown(null); setLeaving(false); } }}
      onPointerEnter={() => setHeld(true)} onPointerLeave={() => setHeld(false)}>
      {shown}
    </div>
  );
}
